import { IconThreeWavesToLeft } from "icons";
import styles from "./SectionTitleLeftWaves.module.scss";

export const SectionTitleLeftWaves = ({ title }) => (
  <div className={styles.container}>
    <IconThreeWavesToLeft className={styles.leftWavesIcon} />
    <h2 className={styles.title}>{title}</h2>
  </div>
);
